import { cn } from '@/lib/utils';

export function Eyebrow({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'font-cinzel block text-[11px] font-semibold uppercase tracking-[0.22em] text-[#554E49]',
        className
      )}
    >
      {children}
    </span>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  centered = false,
  className,
}: {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  centered?: boolean;
  className?: string;
}) {
  return (
    <div className={cn(centered && 'text-center', className)}>
      {eyebrow && <Eyebrow className="mb-4">{eyebrow}</Eyebrow>}
      <h2 className="font-cinzel text-[30px] leading-[1.15] font-bold text-[#231f20] uppercase md:text-[42px]">
        {title}
      </h2>
      {description && (
        <p
          className={cn(
            'font-merriweather mt-5 text-sm leading-relaxed text-[#45423d] md:text-base',
            centered ? 'mx-auto max-w-xl' : 'max-w-xl'
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
}

/** Understated "go deeper" link that points a section at its full page. */
export function SectionLink({
  href,
  children,
  className,
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <a
      href={href}
      className={cn(
        'font-cinzel inline-flex items-center gap-2 border-b border-[#231f20] pb-1.5 text-[11px] font-semibold tracking-[0.18em] text-[#231f20] uppercase transition-colors hover:border-[#948780] hover:text-[#554E49]',
        className
      )}
    >
      {children}
      <span aria-hidden>&rarr;</span>
    </a>
  );
}
